import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { cancelOtherReason } from "../../../../../../../v3/pages/CancelAppointment/routes/default/CancelAppointmentReasons.js";
import { CancelAppointmentReasonTextarea } from "../../../../../../../v3/pages/CancelAppointment/routes/default/CancelAppointmentReasonTextarea.js";
const useGetCancellationQuestions = ({
  configuration,
  textareaLabel,
  errorValidation
}) => {
  const { getLabel } = useIntl();
  return configuration?.map((value) => {
    if (value === cancelOtherReason) {
      return {
        value,
        label: getLabel(`appointments.page.cancel.${value}`),
        content: /* @__PURE__ */ React.createElement(
          CancelAppointmentReasonTextarea,
          {
            label: textareaLabel,
            errorValidation
          }
        )
      };
    }
    return {
      value,
      label: getLabel(`appointments.page.cancel.${value}`)
    };
  });
};
export {
  useGetCancellationQuestions
};
//# sourceMappingURL=use-get-cancellation-questions.js.map
